var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MenuItem',{attrs:{"name":_vm.item.name}},[[_c('Icon',{attrs:{"type":_vm.item.meta.icon,"size":14}}),_vm._v(" "+_vm._s(_vm.item.meta.title)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }